module.exports = {
  title: 'Verification Code Input with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-01-31',
  slug: 'verification-code',
  tags: ['reanimated', 'gesture-handler'],
};
